import { Autocomplete, Box, Button, createMuiTheme, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControlLabel, Modal, Switch, TextField, Typography } from '@mui/material';
import React, { useContext, useEffect, useRef, useState } from 'react'
import DropdownTreeSelect from 'react-dropdown-tree-select';
import { GuardarNuevoActivo, GuardarNuevoTipoActivo, ObtenerArbolActivos, ObtenerTiposActivo } from '../../helpers/ActivosHelper';
import { GuardarNuevoAsunto, ObtenerPrioridades } from '../../helpers/AsuntosHelper';
import { ObtenerUsuarios } from '../../helpers/UsuariosHelper';
import { AsuntosContext } from '../../pages/asuntos/AsuntosPage';
import { ActivosContext } from '../../pages/catalogos/ActivosPage';
import { TiposActivoContext } from '../../pages/catalogos/ActivosTipoPage';
import { AuthContext } from '../../context/AuthContext';

import "react-dropdown-tree-select/dist/styles.css";
import "../../pages/asuntos/AsuntosStyle.css";
import { ModalInstalacionComponent } from './ModalInstalacionComponent';
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  };
export const ModalAgregaAsuntoComponent = () => {
    const {instalacionSeleccionada, setInstalacionSeleccionada,modalSeleccionInstalacion, setModalSeleccionInstalacion,modalAgregaAsunto, setModalAgregaAsunto, obtenerAsuntos, agregandoTarea, setAgregandoTarea, asuntoSeleccionado} = useContext(AsuntosContext)
    const {usuario} = useContext(AuthContext)
    const [errorGuardado, setErrorGuardado] = useState(false);
    const [datosAsunto, setDatosAsunto] = useState({'idUsuario':usuario.IdUsuario, 'cierreCarril':'0'})
    const [responsables, setResponsables] = useState([]);
    const [prioridades, setPrioridades] = useState([]);
    const [instalaciones, setInstalaciones] = useState();
    const [tituloInstalacion, setTituloInstalacion] = useState();
    const [tiposServicio, setTiposServicio] = useState();
    const refForm = useRef();
    console.log('Valor de agregando tarea', agregandoTarea, asuntoSeleccionado);

    const handleClose = () => {
      setDatosAsunto({'idUsuario':usuario.IdUsuario, 'cierreCarril':'0'});
        setModalAgregaAsunto(false);
        setAgregandoTarea(false);
    }

    const obtenerUsuarios = async() => {
      await ObtenerUsuarios().then(datos=> {
        const opciones = new Array();
          datos?.map(dato => {
            opciones.push({...responsables,label:dato.Nombre+' '+dato.ApellidoPaterno, id:dato.IdUsuario})
          })
          setResponsables(opciones);
        })
    }    

    useEffect(() => {
      console.log('selecciono instalacion', instalacionSeleccionada)
      actualizaDatos('idInstalacion',instalacionSeleccionada?.value)
    }, [instalacionSeleccionada])
    
    const obtenerTiposServicio = () => {
      fetch(process.env.REACT_APP_API_URL+'/instalaciones.php?funcion=tiposServicio')
      .then(response => response.json())
      .then(data => {
        console.log('tipos de servicio', data);
        let opciones = new Array();
        data?.map(dato => {
          opciones.push({...tiposServicio,label:dato.descripcion, id:dato.idTipoServicio})
        })        
        setTiposServicio(opciones);
        console.log('opciones despues de map', opciones);
      })
      .catch(error => {
        console.log('Ocurrio un error', error)
      })
    }


    const obtenerInstalaciones =() => {
      ObtenerArbolActivos().then(datos=>setInstalaciones(datos));
    }       

    const obtenerPrioridades = async() => {
      await ObtenerPrioridades().then(datos=> {
        const opciones = new Array();
          datos?.map(dato => {
            opciones.push({...prioridades,label:dato.Prioridad, id:dato.IdPrioridad})
          })
          setPrioridades(opciones);
        })
    }    

    


    const handleSubmit =  async(event) => {
  //      await actualizaDatos('idPadre', activoSeleccionado?.key);
        event.preventDefault();
        //refForm.current.isValidate();
        
        GuardarNuevoAsunto(datosAsunto).then(respuesta => {
            console.log('respuesta de guardado en modal', respuesta);
            if(respuesta!=1) {
                setErrorGuardado(true);
            } else{
                setErrorGuardado(false);
                obtenerAsuntos();
                handleClose();

            }
        })
    }


    const actualizaDatos = (dato, valor) => {
      setDatosAsunto({
          ...datosAsunto,
          [dato]:valor
      })
    }

    function onChange(currentNode, selectedNodes) {
      // currentNode: { label, value, children, expanded, checked, className, ...extraProps }
      // selectedNodes: [{ label, value, children, expanded, checked, className, ...extraProps }]
      console.log('cambio el nodo',currentNode);
      setTituloInstalacion(currentNode?.title)
      actualizaDatos('idInstalacion', currentNode.value)
    }    

 
    // useEffect(() => {
    //   console.log('datos activo', datosActivo);
    // }, [datosActivo])

    useEffect(() => {
      obtenerUsuarios();
      obtenerPrioridades();
      obtenerInstalaciones();
      obtenerTiposServicio();
    }, [])
    
    useEffect(() => {
      if(agregandoTarea) {
        console.log('asunto seleccionado para agregar tarea', asuntoSeleccionado)
        actualizaDatos('idAsuntoPadre',asuntoSeleccionado.IdAsunto)
        setInstalacionSeleccionada({
          'title':asuntoSeleccionado.Ruta,
          'value':asuntoSeleccionado.IdInstalacionPadre
        })
      }
    }, [agregandoTarea])
    

    useEffect(() => {
      console.log('datos asunto', datosAsunto)
    }, [datosAsunto])
    

  return (
    <>
      <div
        style={{
            minWidth:600, minHeight:800
        }}
    >
     <Dialog open={modalAgregaAsunto} onClose={handleClose}>
        <form onSubmit={handleSubmit} ref={refForm}>
        <DialogTitle>
          <Typography
            style={{
              fontSize:'1.25rem',
              fontWeight:'500'
            }}
          >
            {
              agregandoTarea ? (
                 <>Agregar Tarea</>
                )
              :
              (
                <>Agregar Asunto</>
              )
            }
          </Typography>
 
        </DialogTitle>
        <DialogContent
            style={{minWidth:600}}
        >
          <Button
            onClick={() => {
              setModalSeleccionInstalacion(true);
            }}
          >Seleccionar instalación</Button>
          <Typography>
            {instalacionSeleccionada?.title || 'Da click en Seleccionar Instalación'}
          </Typography>
          <Autocomplete
            onChange={(event, newValue) => {actualizaDatos('idResponsable', newValue.id)}}
            autoFocus
            //disablePortal
            id="combo-box-demo"
            options={responsables}
            sx={{ width: '100%', zIndex:9999999 }}
            style={{zIndex:999999}}
            renderInput={(params) => <TextField variant='standard'  autoFocus style={{zIndex:9999999, backgroundColor:'white', marginTop:5}} {...params} label="Responsable" />}
          />
          <Autocomplete
            onChange={(event, newValue) => {actualizaDatos('idTipoServicio', newValue.id)}}
            //disablePortal
            id="combo-box-demo"
            options={tiposServicio}
            sx={{ width: '100%', zIndex:9999999 }}
            style={{zIndex:999999}}
            renderInput={(params) => <TextField variant='standard'   style={{zIndex:999999, backgroundColor:'white', marginTop:10, marginBottom:20}} {...params} label="Prioridad" />}
          />
          <Autocomplete
            onChange={(event, newValue) => {actualizaDatos('idPrioridad', newValue.id)}}
            //disablePortal
            id="combo-box-demo"
            options={prioridades}
            sx={{ width: '100%', zIndex:9999999 }}
            style={{zIndex:999999}}
            renderInput={(params) => <TextField variant='standard'   style={{zIndex:999999, backgroundColor:'white', marginTop:10, marginBottom:20}} {...params} label="Prioridad" />}
          />
          <TextField
            margin="dense"
            id="name"
            multiline={true}
            rows={3}
            name="txtTipoActivo"
            label="Descripción"
            type="text"

            fullWidth
            variant="standard"
            required={true}
            onChange={(e) => actualizaDatos('descripcion', e.target.value)}
         //   value={datosAsunto?.descripcion}
          />

          <TextField
            margin="dense"
            id="name"
            name="txtTipoActivo"
            label="Fecha esperada"
            type="date"
            fullWidth
            variant="standard"
            InputLabelProps={{shrink:true}}
            required={true}
            onChange={(e) => actualizaDatos('fechaEsperada', e.target.value)}
            //value={datosAsunto?.fechaEsperada}
          />
          <FormControlLabel control={<Switch onChange={(e) => actualizaDatos('cierreCarril', e.target.checked ? '1':'0' )} />} label="Cierre de carril?" />
          {
            errorGuardado && (
              <Typography
                style={{
                    fontSize:12,
                    color:'red'
                }}
              >
                Error al guardar
            </Typography>
            )
          }
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancelar</Button>
          <Button type='submit' >Guardar</Button>
        </DialogActions>
        </form>
      </Dialog>
    </div>
    <ModalInstalacionComponent />
    </>
  )
}
